import { inject, Injectable } from '@angular/core';
import { Token } from '@domain/entities/session.entity';
import { LoggerService } from '../logger';
import {
  STORAGE_KEYS,
  STORAGE_PREFIXES,
} from '../storage/storage-keys.constants';
import { StorageService, StorageType } from '../storage/storage.service';

@Injectable({ providedIn: 'root' })
export class TokenStorageService {
  logger = inject(LoggerService);

  constructor(private readonly _storageService: StorageService) {}

  save(token: Token | null): void {
    this.logger.debug('TokenStorageService', 'save', token);
    if (token) {
      this._storageService.set(STORAGE_KEYS.AUTH_TOKEN, token, {
        type: StorageType.LOCAL,
        encrypt: true,
        prefix: STORAGE_PREFIXES.APP,
      });
    } else {
      this._storageService.remove(STORAGE_KEYS.AUTH_TOKEN, {
        prefix: STORAGE_PREFIXES.APP,
      });
    }
  }

  get(): Token | null {
    this.logger.debug('TokenStorageService', 'get');
    return this._storageService.get(STORAGE_KEYS.AUTH_TOKEN, {
      type: StorageType.LOCAL,
      encrypt: true,
      prefix: STORAGE_PREFIXES.APP,
    }) as Token | null;
  }

  remove(): void {
    this.logger.debug('TokenStorageService', 'remove');
    this._storageService.remove(STORAGE_KEYS.AUTH_TOKEN, {
      prefix: STORAGE_PREFIXES.APP,
    });
  }
}
